module.exports = __webpack_public_path__ + "static/media/30.1286288e.wav";